import { useTranslations } from '@ms/yammer-i18n-react';
import ErrorStrings from '@ms/yammer-strings/dist/Error';
import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import Clickable from '@ms/yammer-web-core-ui/dist/components/Clickable';
import FakeLink from '@ms/yammer-web-core-ui/dist/components/FakeLink';
import Heading from '@ms/yammer-web-core-ui/dist/components/Heading';
import Image from '@ms/yammer-web-core-ui/dist/components/Image';
import Paragraph from '@ms/yammer-web-core-ui/dist/components/Paragraph';
import VerticalAlign from '@ms/yammer-web-core-ui/dist/components/VerticalAlign';
import { useTheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import React, { FC } from 'react';

import { vivaEngageLogoPath } from '../../images';

import { getClassNames } from './FailedToLoad.styles';

const reload = () => window.location.reload();

interface FailedToLoadProps {
  readonly error?: unknown;
  readonly title?: string;
}

const FailedToLoad: FC<FailedToLoadProps> = ({ error = '', title = '' }) => {
  const t = useTranslations(ErrorStrings);

  const theme = useTheme();
  const { yammerLogo: yammerLogoClassName } = getClassNames(theme);

  // brmckeon suggested this raw english fallback in case our translations failed to load too
  const fallbackCallToAction = (
    <>
      Please <FakeLink key="failed-to-load-link">try again</FakeLink> in a few minutes.
    </>
  );

  const preferredCallToAction = t.failedToLoadCallToAction({
    link: (text) => <FakeLink key="failed-to-load-link">{text}</FakeLink>,
  });

  const callToAction = preferredCallToAction || fallbackCallToAction;

  const heading = title || t.failedToLoadMessage();
  const content = error ? (
    <Block paddingTop={3}>{error as string}</Block>
  ) : (
    <Clickable onClick={reload} display="block" unstyled={true}>
      <Paragraph>{callToAction}</Paragraph>
    </Clickable>
  );

  return (
    <VerticalAlign horizontalAlign="center" height="100vh">
      <div className={yammerLogoClassName}>
        <Image source={vivaEngageLogoPath} description="" shouldFadeIn={false} />
      </div>
      <Heading size="3">{heading}</Heading>
      {content}
    </VerticalAlign>
  );
};

export default FailedToLoad;
